import { FC, useState } from 'react'
import { magentoApi } from '../../services/magento.api'
import NestedList from '../nestedList/NestedList'
import { ICategory } from '../../../model/ICategory'
import Loading from '../common/loading/Loading'
import NoData from '../common/empty/NoData'
import { ICategoryIdsItem } from '../../../model/IImportForm'

const CategoriesTree: FC<{
  categoryIds?: ICategoryIdsItem[]
  setCategoryIds?: (updatedList: ICategoryIdsItem[]) => unknown
}> = ({ categoryIds = [], setCategoryIds = () => {} }) => {
  const { data: categories, isFetching, isLoading } = magentoApi.useGetCategoriesQuery({})

  const onToggle = (id: ICategoryIdsItem) =>
    setCategoryIds(
      categoryIds.includes(id)
        ? categoryIds.filter((idItem) => idItem != id)
        : [...categoryIds, id],
    )

  return (
    (categories && categories?.length && (
      <NestedList items={categories} selectedIds={categoryIds} onToggle={onToggle} />
    )) ||
    ((isFetching || isLoading) && <Loading />) || <NoData msg='Categories not found!' />
  )
}

export default CategoriesTree
